import { useEffect } from 'react';

interface UseActionsHistoryEffects {
  fetchUserHistoryFilterData(): Promise<void>;
  fetchUserHistory(): Promise<void>;
}

export const useActionsHistoryEffects = ({
  fetchUserHistoryFilterData,
  fetchUserHistory,
}: UseActionsHistoryEffects) => {
  useEffect(() => {
    fetchUserHistoryFilterData();
  }, [fetchUserHistoryFilterData]);

  useEffect(() => {
    fetchUserHistory();
    // Добавление в список зависимостей fetchUserHistory приводит к тому,
    // что при смене количества строк на странице вызывается SearchUserHistory дважды,
    // а дата начала периода в фильтрах слетает
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
